import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { OutlinedBtnPrimary, SectionTitle } from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useEspelhoNota, { ESPELHO_NOTAS_ACTIONS } from './EspelhoNotaState'

export default connect()(EspelhoNota)

function EspelhoNota({ ciclo, dispatch }) {
  const { state, actions } = useEspelhoNota(ciclo)

  useEffect(() => {
    switch (state.loading) {
      case ESPELHO_NOTAS_ACTIONS.LOADING_ESPELHO_NOTA:
        dispatch(showLoadingBox('Obtendo Espelho de Entregas', 'Aguarde . . .'))
        break
      default:
        dispatch(hideLoadingBox())
        break
    }
  }, [state.loading])

  useEffect(() => {
    state.errorMessage &&
      dispatch(showMessageBox(null, state.errorMessage)) &&
      actions.resetMessages()
    state.successMessage &&
      dispatch(showMessageBox(state.successMessage, null)) &&
      actions.resetMessages()
  }, [state.errorMessage, state.successMessage])

  // Render
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <SectionTitle title="Espelho de Entregas" />
      </div>
      <div className="p-col-12">
        <OutlinedBtnPrimary label="Gerar Espelho" onClick={actions.onBtnEspelhoClick} />
      </div>
    </div>
  )
}
